import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';

import CourseDetailSection from '@components/templates/courseDetail/courseDetailSection';
import { useCourseDiscussionList } from '@hooks/course/courseDiscussion/useCourseDiscussionList';
import { useCourseReview } from '@hooks/course/courseReview/useCourseReview';
import useCourseDetail from '@hooks/course/useCourseDetail';
import useCourseEnrollment from '@hooks/course/useCourseEnrollment';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type CourseDetailProps = {
  courseDetailSeo: CourseEntity;
};

const CourseDetail: FC<CourseDetailProps> = ({ courseDetailSeo }) => {
  const router = useRouter();

  const courseIdOrIdName = router?.query?.idName as string;
  const { id: courseId } = courseDetailSeo;
  const { handleFetchCourseDetail, handleResetCourseDetail } = useCourseDetail();
  const { handleResetCourseDiscussion } = useCourseDiscussionList({ idName: courseIdOrIdName });
  const { handleResetCourseReview } = useCourseReview({ idName: courseIdOrIdName });
  const { handleFetchCourseEnrollment, handleResetCourseEnrollment } = useCourseEnrollment();

  useEffect(() => {
    if (!courseIdOrIdName) {
      return;
    }
    handleFetchCourseDetail(courseIdOrIdName as string);
    return () => {
      handleResetCourseDetail();
      handleResetCourseEnrollment();
      handleResetCourseReview();
      handleResetCourseDiscussion();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseIdOrIdName]);

  useEffect(() => {
    if (!courseId) {
      return;
    }
    handleFetchCourseEnrollment(courseId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId]);

  return (
    <>
      <CourseDetailSection courseDetailSeo={courseDetailSeo} />
    </>
  );
};

export default CourseDetail;
